<template>
    <div class="container remove-padding-margin" id="SettahapanWorkshop">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClicked === true"></span>
        </div>
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back(datalistworkshop.idworkshop)">
                    <img src="../../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Atur Tahapan Produksi</h6>
                </div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <div class="text-outlets mar-bottom-16 mar-top-60">
                        <div class="font-16 mar-bot-2"><b>Pilih Jenis Pekerjaan</b></div>
                        <div class="font-16 set-text">Silahkan pilih apa saja tahapan produksi yang akan dikerjakan</div>
                    </div>
                    <div class="custom-control custom-checkbox remove-padding" v-for="data in checklisttahapan"
                         :key="data.idtahapan">
                        <input type="checkbox" class="custom-control-input" v-if="data.idtahapan == '8000'" :value="data.idtahapan" disabled checked="true" v-bind:id="data.idtahapan" v-model="dataProses">
                        <input type="checkbox" class="custom-control-input" v-else-if="data.status == '1'" :value="data.idtahapan" checked="true" v-bind:id="data.idtahapan" v-model="dataProses">
                        <input type="checkbox" class="custom-control-input" v-else v-bind:id="data.idtahapan" :value="data.idtahapan" checked="false" v-model="dataProses">
                        <label class="custom-control-label label-checklist" v-bind:for="data.idtahapan">
                            {{data.text}}</label>
                    </div>
                    <div >
                        <div class="text-outlets font-14 mar-top-8"><span class="color-206CF">*</span>pengemasaan wajib dilakukan dalam produksi</div>
                    </div>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" id="btnNext" @click="Edittahapan">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked1 === true"></span>
                        <span id="textBtn2">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "SetTahapanWorkshop",
        props:['datalistworkshop'],
        data() {
            return {
                isClicked:false,
                isClicked1: false,
                dataTahapan: [],
                dataProses:[],
                checklisttahapan: [],
                idworkshop: '',
                dataCheckTahapan: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }

            }
        },
        mounted() {
            this.idworkshop = this.$route.params.idworkshop
            this.getTahapan();
            this.getChecklist();
            $('#close').hide();

        },
        methods: {
            back(idworkshop) {
                this.$emit('backtodetail',idworkshop);
            },
            async getChecklist() {
                this.isClicked = true
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_workshop_meta?idworkshop=' + this.datalistworkshop.idworkshop, this.requestHeaders);
                    if (response.status === 200) {
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.dataCheckTahapan.push({idtahapan: rawtahapan[i].idtahapan})
                            this.dataProses.push(rawtahapan[i].idtahapan)
                        }
                    }
                        const response2 = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta', this.requestHeaders)
                    if (response2.status === 200) {
                        var arrayTahapan = this.dataCheckTahapan;
                        var rawtahapan2 = response2.data.data;
                        for (var i = 0; i < rawtahapan2.length; i++) {
                            var status = this.checkValue(rawtahapan2[i].idtahapan, arrayTahapan)
                            this.checklisttahapan.push({
                                idtahapan: rawtahapan2[i].idtahapan,
                                text: rawtahapan2[i].nama,
                                status: status
                            })
                        }
                    }
                    this.isClicked=false
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                	this.$catch_error_response(e)
                    this.isClicked1=false
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false)
                }
            },
            async getTahapan() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta', this.requestHeaders);
                    if (response.status === 200) {
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.dataTahapan.push({idtahapan: rawtahapan[i].idtahapan, text: rawtahapan[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                    this.isClicked1=false
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false)
                }
            },

            checkValue(value, arr) {
                var status = '0';

                for (var i = 0; i < arr.length; i++) {
                    var name = arr[i].idtahapan;
                    if (name == value) {
                        status = '1';
                        break;
                    }
                }

                return status;
            },
            async Edittahapan(){
                this.isClicked1=true
                $('#textBtn2').hide()
                $('#btnNext').prop('disabled', true)
                try {
                    const edit = new FormData
                    for(var i = 0; i < this.dataProses.length; i ++) {
                        edit.append('tahapan[]', this.dataProses[i])
                    }
                    console.log(FormData)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_tahapan_workshop?idworkshop=' + this.datalistworkshop.idworkshop, edit, this.requestHeaders)
                    if(response.data.status===true){
                        this.back()
                    }
                    this.isClicked1=false
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false)
                }catch (e) {
                	this.$catch_error_response(e)
                    this.isClicked1=false
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false)
                }
            },
        }
    }
</script>

<style scoped>
    .set-text{
        font-weight: normal;
        font-size: 14px;
        line-height: 140%;
        letter-spacing: -0.02em;
        color: #333333;
    }
    .label-checklist{
        line-height: 28px;
        letter-spacing: -0.02em;
        color: #000000;
    }
    .text-outlets{
        line-height: 140%;
        letter-spacing: -0.02em;
        color: #333333;
    }
</style>